export const BASE_URL = "https://lk.xbadm.ru";
// export const BASE_URL = "http://events.mosgorweb.ru";
